// extracted by mini-css-extract-plugin
export var card = "_r0-0";
export var content = "_r0-2";
export var details = "_r0-3";
export var icon = "_r0-1";
export var iconBlue = "_r0-5";
export var iconBrand = "_r0-4";
export var iconGrayBlue = "_r0-6";
export var iconGreen = "_r0-7";
export var iconIndigo = "_r0-8";
export var iconOrange = "_r0-9";
export var iconPurple = "_r0-a";
export var iconRed = "_r0-b";
export var iconWarning = "_r0-c";